import { DragOutlined } from '@ant-design/icons';
import { Checkbox } from 'antd5';
import { Draggable } from 'react-beautiful-dnd';

import { ColumnName, ListItemContainer, ToggleContainer } from './ColumnListItem.style';

export function ColumnListItem({ index, column, toggleVisibility }) {
  // The title sits beside the checkbox rather than labelling it, so name the
  // control explicitly. Titles can be nodes, which cannot become a label.
  const accessibleName = typeof column.title === 'string' ? column.title : undefined;

  if (column.fixed) {
    return (
      <ListItemContainer data-testid="customize-column-row">
        <ToggleContainer>
          <Checkbox checked={column.visible} disabled={true} aria-label={accessibleName} />
          <ColumnName>{column.title}</ColumnName>
        </ToggleContainer>
      </ListItemContainer>
    );
  }

  return (
    <Draggable draggableId={column.key} index={index}>
      {(provided, snapshot) => (
        <ListItemContainer
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          $isDragging={snapshot.isDragging}
          $isHidden={column.hidden}
          data-testid="customize-column-row"
        >
          <ToggleContainer>
            <Checkbox
              checked={column.visible}
              onChange={() => toggleVisibility(column)}
              aria-label={accessibleName}
            />
            <ColumnName>{column.title}</ColumnName>
          </ToggleContainer>
          <DragOutlined />
        </ListItemContainer>
      )}
    </Draggable>
  );
}
